import "./App.css";
import Home from "./pages/Home";
import MapRoutes from "./pages/MapRoute";
import Tour from "./pages/Tour";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LocationFilter from "./pages/LocationFilter";
import { LocationProvider } from "./services/LocationContext";
import { TourProvider } from "./services/TourContext";
import Header from "../src/components/Header";
import logger from "./services/Logger";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Register from "./pages/Register";
import { AuthProvider } from "./services/authContext";
import GlobalErrorBoundary from "./components/GlogalErrorBoundary";
import * as Sentry from "@sentry/react";
import { GOOGLE_APIKEY } from "./consts";
const srcValue = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_APIKEY}&libraries=places`;

loadScript(srcValue);

function loadScript(url) {
  const script = document.createElement("script");
  script.src = url;
  script.async = true;
  document.body.appendChild(script);
}

Sentry.init({
  dsn: "https://66026650d2221b2cc71a482d06f749bc@o4508892597911552.ingest.us.sentry.io/4508892600860672",
  integrations: [],
  tracesSampleRate: 1.0,
});

function App() {
  logger.setLogLevel("DEBUG");
  return (
    <GlobalErrorBoundary>
      <AuthProvider>
        <LocationProvider>
          <TourProvider>
            <Router>
              <Header />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/MapRoutes" element={<MapRoutes />} />
                <Route path="/Tour" element={<Tour />} />
                <Route path="/LocationFilter" element={<LocationFilter />} />
                <Route path="/Login" element={<Login />} />
                <Route path="/Profile" element={<Profile />} />
                <Route path="/Register" element={<Register />} />
              </Routes>
            </Router>
          </TourProvider>
        </LocationProvider>
      </AuthProvider>
    </GlobalErrorBoundary>
  );
}

export default App;
